export const MARKETING_EVENTS = {
    FORM_SUBMIT: 'form_submit',
    LANDING_PAGE_VIEW: 'landing_page_view',
    INITIATE_REG: 'initiate_reg'
};

export const triggerEvent = (event, eid) => {
    if (typeof window !== 'undefined') {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({ event, eid });
    }
};
